import { UseBaseMutationOptions } from '@/core/api/type'
import { useMutation } from '@tanstack/react-query'
import { TagsMutationKeys } from '../../constants'
import { deletePlayerTag } from '../services'

interface DeletePlayerTagParams {
	id: string
}

export default function useMutationDeletePlayerTag(
	props?: UseBaseMutationOptions<void, DeletePlayerTagParams>,
) {
	return useMutation({
		mutationKey: [TagsMutationKeys.DeleteTag],
		mutationFn: (params) => deletePlayerTag(params.id),
		...props,
	})
}
